import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'input-rating',
  templateUrl: './input-rating.component.html',
  styleUrls: ['./input-rating.component.css']
})
export class InputRatingComponent   {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() length: number = 5;

  public arrayRating = [];

  constructor() {
  }

  ngAfterContentInit (): void {

    this.arrayRating = Array(this.length).fill(0).map((x, i) => i+1);
  }
}
